export default __webpack_public_path__ + "static/media/img-tests.67712797.png";